import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, IUtilsDictionary, LoggingService, UtilsJson, UtilsMisc, UtilsString } from '@pit/core';
import { EntityDataService } from '@pit/core-data';
import { IDtoAppVersion, DtoAppVersion, IDtoArchive, DtoArchive } from '@pit/frontend-model';
import { map, Observable } from 'rxjs';
import { IDtoAppVersionEntityDataService } from '../interfaces/dto.app.version.entity.data.service.interface';
import { IDtoArchiveEntityDataService } from '../interfaces/dto.archive.entity.data.service.interface';

@Injectable({
  providedIn: 'root'
})
export class DtoArchiveEntityDataService extends EntityDataService<IDtoArchive> implements IDtoArchiveEntityDataService {

  constructor(http: HttpClient, configService: ConfigService, loggingService: LoggingService) {
    super(http, null, configService, loggingService);
  }

  public getItemsByShipmentNumberAndMandator$(mandator: string, shipmentNumber: string): Observable<IDtoArchive[]> {
    return this.httpGet(`api/web/archives/mandator/${mandator}/${shipmentNumber}`)
      .pipe(map((entities: IDtoArchive[]) => {
        const result: IDtoArchive[] = [];
        if ((UtilsMisc.isNullOrUndefined(entities) === false) && (entities.length > 0)) {
          for (const entity of entities) {
            result.push(this.createEntityFromJson(entity));
          }
        }
        return result;
      }));
  }

  public async getItemsByShipmentNumberAndMandatorAsync(mandator: string, shipmentNumber: string): Promise<IDtoArchive[]> {
    return (await this.getItemsByShipmentNumberAndMandator$(mandator, shipmentNumber).toPromise());
  }

  protected override doGetApiUrl(): string {
    return UtilsString.stringFormat('{0}/archives', this.configurationService.configData.urlApi);
  }

  protected override createEntityFromJson(json: any): IDtoArchive {
    const result: IDtoArchive = (UtilsJson.deserialize(json, DtoArchive) as IDtoArchive);
    if (result !== null) {
      result.setReferences();
    }

    return result;
  }

  protected override doGetUrls(): IUtilsDictionary<string> {
    this._urls = super.doGetUrls();

    this._urls.add('get.by.number.mandator', UtilsString.stringFormat('{0}://{1}:{2}/{3}/mandator/', this.configurationService.configData.protocol, this.configurationService.configData.ip, this.configurationService.configData.port, this.apiUrl) + '{0}/{1}');

    return this._urls;
  }

}
